/** @jsx jsx */
import { Children } from 'react';
import { css, jsx } from '@emotion/core';
import { BORDER_WIDTH } from '@atlaskit/avatar';
import { gridSize } from '@atlaskit/theme/constants';
var gutter = BORDER_WIDTH * 2 + gridSize() / 2;
var listStyles = css({
  display: 'flex',
  margin: 0,
  marginRight: gutter,
  padding: 0,
  lineHeight: 1,
  listStyleType: 'none !important'
});
var listItemStyles = css({
  margin: 0,
  marginRight: -gutter
});

var Stack = function Stack(_ref) {
  var children = _ref.children,
      testId = _ref.testId,
      label = _ref['aria-label'];
  return jsx("ul", {
    "data-testid": testId,
    "aria-label": label,
    css: listStyles
  }, Children.map(children, function (child) {
    return child && jsx("li", {
      css: listItemStyles
    }, child);
  }));
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc


export default Stack;